import { render, staticRenderFns } from "./ManhattanPlot.vue?vue&type=template&id=4d59e7dc&scoped=true&"
import script from "./ManhattanPlot.vue?vue&type=script&lang=js&"
export * from "./ManhattanPlot.vue?vue&type=script&lang=js&"
import style0 from "./ManhattanPlot.vue?vue&type=style&index=0&id=4d59e7dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d59e7dc",
  null
  
)

export default component.exports